/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import { gql } from '@apollo/client';

const findTrendingProducts = (queryName = 'TrendingProducts') => gql`
    query ${queryName}(
        $brand: String!
        $environment: String!
        $customerType: CustomerType
        $locationType: LocationType
        $dateRange: Int
        $pageSize: Int
        $filters: Filters
        $browserUUID: String!
    ) {
        trendingProducts(
            brand: $brand
            browserUUID: $browserUUID
            environment: $environment
            customerType: $customerType
            locationType: $locationType
            dateRange: $dateRange
            pageSize: $pageSize
            filters: $filters
        ) {
            topProducts {
                product {
                    brand
                    productType
                    partNumber
                    name
                    seo {
                        url
                    }
                    image {
                        name
                        path
                        snipe
                        snipeImagePath
                        altText
                    }
                    skuPriceRange {
                        sale {
                            currency
                            type
                            value
                        }
                        retail {
                            currency
                            type
                            value
                        }
                    }
                    longDescription
                    shortDescription
                    isPassportEligible
                    productSkus {
                        partNumber
                        name
                        occasion
                        sympathyValue
                    }
                    productDeliveryType
                }
                primaryBrand
                locationType
                topProductWeight
            }
        }
    }
`;

export default findTrendingProducts;
